// extracted by mini-css-extract-plugin
export default {"container":"PJ-z","dimension":"QJ-z","dimensionLabels":"RJ-z"};